import PortalAccess from './PortalAccess';

export default PortalAccess;
